import { styles } from './template.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_MAIN_FORM } from '../../../../../webcomponents.constants';

export const template = document.createElement('template');

template.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='form-wrapper'>
      <${WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_MAIN_FORM}></${WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_MAIN_FORM}>
    </div>

    <div class='bottom-buttons'>
      <gz-button id='save-button' disabled></gz-button>
      <div class='flex-auto'></div>
      <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
    </div>
  </div>
`;
